import _ from 'lodash';

import { Validators } from '@angular/forms';

export const SeatsPresetOptionSchema = {
  'fields': [{
      'field': 'tableNumber',
      'type': 'number',
      'value': 0,
      'column': 0,
      'validators': [Validators.required, Validators.min(1)],
      'options': {
        'getter': (control) => parseInt(control.value) || 0,
        'setter': (data, value) => parseInt(value) || 0
      }
    }, {
      'field': 'seatNumber',
      'type': 'number',
      'value': 0,
      'column': 1,
      'validators': [Validators.required, Validators.min(1)],
      'options': {
        'getter': (control) => parseInt(control.value) || 0,
        'setter': (data, value) => parseInt(value) || 0
      }
    }, {
      'field': 'seatName',
      'type': 'string',
      'value': '',
      'column': 2,
      'validators': [Validators.maxLength(16)]
    }
  ]
}

